import { render, staticRenderFns } from "./cadastro_novo_administrativo.vue?vue&type=template&id=6e641d3c&scoped=true"
import script from "./cadastro_novo_administrativo.vue?vue&type=script&lang=js"
export * from "./cadastro_novo_administrativo.vue?vue&type=script&lang=js"
import style0 from "./cadastro_novo_administrativo.vue?vue&type=style&index=0&id=6e641d3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e641d3c",
  null
  
)

export default component.exports